import React from 'react';
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { Envelope, EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { Dropdown } from 'react-bootstrap';
import ImgRed from '../../images/red-bullet.gif';
import ImgOrange from '../../images/orange-bullet.gif';
import ImgGreen from '../../images/green-bullet.gif';
import ImgEQ from "../../images/EQ_Blue.png";
import ImgFL from "../../images/FL_Blue.png";
import ImgNL from "../../images/NL_Blue.png";
import ImgT2 from "../../images/T2_Blue.png";
import ImgTC from "../../images/TC_Blue.png";
import { getAPI } from '../GdacsAPI';

const NewServiceRow = (props) => {
    const [service, setService] = React.useState({ idServiceType: "", eventType: "", alertLevel: "", region: "", language: "", stopNight: false, enabled: true });
    const [servicestypes, setServicesTypes] = React.useState([]);
    const [regions, setRegions] = React.useState([]);
    const [servicestypesdevice, setServicesTypesDevice] = React.useState([]);
    const [alertLevel, setAlertLevel] = React.useState(["Red", "Orange", "Green"]);
    const [language, setLanguage] = React.useState([]);
    const [alertsBycode, setAlertsBycode] = React.useState([])
    const [eventtypes, setEventTypes] = React.useState([]);
    const [toggleContents, setToggleContents] = React.useState();
    const [toggleEvents, setToggleEvents] = React.useState();
    const [toggleAlerts, setToggleAlerts] = React.useState();
    const [toggleRegions, setToggleRegions] = React.useState();
    const [toggleLanguages, setToggleLanguages] = React.useState();
    const [serviceDisabled, setServiceDisabled] = React.useState(false);
    const [alertDisabled, setAlertDisabled] = React.useState(false);
    const [regionDisabled, setRegionDisabled] = React.useState(false);
    const [languageDisabled, setLanguageDisabled] = React.useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isModified, setIsModified] = React.useState(true);

    React.useEffect(() => {
        props.isButtonDisabled(isButtonDisabled);
        props.responseMessage(responseMessage);
        props.isModified(isModified);
    }, [])

    async function GetEventTypes() {
        var url = getAPI() + `api/register/Definition/eventtypes/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEventTypes('Failed to retreive event types data.');
            return;
        }
        const eventtypesData = await response.json();
        if (eventtypesData) {
            setEventTypes(eventtypesData);
        }
    }

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes('Failed to retreive services types data.');
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypes(servicesTypesData);
            setServicesTypesDevice(servicesTypesData);
            setLanguage(servicesTypesData[0].listLanguages);
        }
    }

    async function GetRegions() {
        var url = getAPI() + `api/register/Definition/regions/`;
        const response = await fetch(url);
        if (!response.ok) {
            setRegions('Failed to retreive regions data.');
            return;
        }
        const regionsData = await response.json();
        if (regionsData) {
            setRegions(regionsData);
        }
    }


    React.useEffect(() => {
        GetEventTypes();
        GetServicesTypes();
        GetRegions();
    }, []);

    const handleChangeService = (e) => {
        setService((a) => ({ ...a, idServiceType: parseInt(e) }));
        props.isModified(isModified);
    }

    const handleChangeEvent = (e) => {
        setService((a) => ({ ...a, eventType: e }));
        if (e === "NL") {
            setServiceDisabled(true);
            setAlertDisabled(true);
            setRegionDisabled(true);
            setLanguageDisabled(true);
        }
        else {
            setServiceDisabled(false);
            setAlertDisabled(false);
            setRegionDisabled(false);
            setLanguageDisabled(false);
        }
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeAlertLevel = (e) => {
        setService((a) => ({ ...a, alertLevel: e }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeRegion = (e) => {
        setService((a) => ({ ...a, region: parseInt(e) }));
        props.responseMessage("");
        props.isModified(true);
    }

    const handleChangeLanguage = (e) => {
        setService((a) => ({ ...a, language: e }));
        props.responseMessage("");
        props.isModified(true);
    }

    async function GetAlertsByChannel(idservicetype) {
        var url = getAPI() + `api/register/Definition/JoinESAllByIdservice?idService=` + idservicetype;
        const response = await fetch(url);
        if (!response.ok) {
            setAlertsBycode('Failed to retreive services types data.');
            return;
        }

        const servicesAlerts = await response.json();

        let lang = servicestypesdevice.filter(x => x.idServiceType === idservicetype);

        if (servicesAlerts) {
            setAlertLevel(servicesAlerts[0].listAlertlevels);
            setToggleAlerts(icons[servicesAlerts[0].listAlertlevels]);
            setLanguage(lang[0].listLanguages);
            setToggleLanguages(lang[0].listLanguages[0].value);
        }
    }

    async function GetAlerts(eventtype) {
        var url = getAPI() + `api/register/Definition/JoinESAllByCode?code=` + eventtype;
        const response = await fetch(url);
        if (!response.ok) {
            setAlertsBycode('Failed to retreive services types data.');
            return;
        }

        const servicesAlerts = await response.json();
        const obj = [...servicesAlerts];

        let p = obj.filter(a => a.eventtypecode === eventtype);


        const filter = [...servicestypesdevice];
        /*        setServicesTypes([]);*/

        let a = [];

        for (var i = 0; i < p.length; i++) {

            const idtype = p[i].idservicetype;
            if (idtype === 1 || idtype === 3) {
                let servtype = filter.find((item) => (item.idServiceType === idtype));
                a.push(servtype);
            }
        }

        if (servicesAlerts) {
            /*            setAlertsBycode(servicesAlerts);*/
            setServicesTypes(a);
            setToggleContents(icons[a.idServiceType]);
            setLanguage(a[0].listLanguages);
            setToggleLanguages(a[0].listLanguages[0].value);
            setAlertLevel(p[0].listAlertlevels);
            setToggleAlerts(icons[p[0].listAlertlevels]);
        }
    }

    const handleChangeCheckNight = (e) => {
        const newValue = e.currentTarget.checked;
        setService((a) => ({ ...a, stopNight: newValue }));
        props.responseMessage("");
        props.isModified(true);
    };

    const handleChangeCheckEnabled = (e) => {
        const newValue = e.currentTarget.checked;
        setService((a) => ({ ...a, enabled: newValue }));
        props.responseMessage("");
        props.isModified(true);
    };

    React.useEffect(() => {
        if (servicestypes.length > 0) {
            const newValue = parseInt(servicestypes[0].idServiceType);
            setService((a) => ({ ...a, idServiceType: newValue }));
        }

    }, [servicestypes]);

    React.useEffect(() => {
        if (service.eventtype === undefined && eventtypes.length > 0)
            setService((a) => ({ ...a, eventType: eventtypes[0].eventtype }));
    }, [eventtypes]);

    React.useEffect(() => {
        if (regions.length > 0) {
            const newValue = parseInt(regions[0].idRegion);
            setService((a) => ({ ...a, region: newValue }));
        }
    }, [regions]);

    React.useEffect(() => {
        if (language.length > 0) {
            const newValue = language[0].key;
            setService((a) => ({ ...a, language: newValue }));
        }
        else {
            const newValue = "en";
            setService((a) => ({ ...a, language: newValue }));
        }
    }, [language]);

    React.useEffect(() => {
        if (alertLevel.length > 0) {
            const newValue = alertLevel[0];
            setService((a) => ({ ...a, alertLevel: newValue }));
        }
        else {
            const newValue = "Red";
            setService((a) => ({ ...a, alertLevel: newValue }));
        }
    }, [alertLevel]);

    const icons = {
        "1": <EnvelopeFill color="#0099CC" size={18} />,
        "3": <Telephone color="#0099CC" size={18} />,
        "10": <Phone color="#0099CC" size={18} />,
        "Red": <img src={ImgRed} />,
        "Orange": <img src={ImgOrange} />,
        "Green": <img src={ImgGreen} />,
        "EQ": <img src={ImgEQ} className="icon_table" />,
        "FL": <img src={ImgFL} className="icon_table" />,
        "NL": <img src={ImgNL} className="icon_table" />,
        "T2": <img src={ImgT2} className="icon_table" />,
        "TC": <img src={ImgTC} className="icon_table" />,
    };


    return (
        <tr>
            <td className="cell_hidden">{props.service.id}</td>
            <td className="cell_hidden">{props.service.idService}</td>
            <td className="cell_alerts">
                <Dropdown onSelect={eventKey => {
                    setToggleEvents(icons[eventKey]);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light">
                        {!toggleEvents ? <img src={`Images/EQ_Blue.png`} className="icon_table" /> : toggleEvents}
                    </Dropdown.Toggle>

                    <Dropdown.Menu value={service.eventtype} >
                        {
                            eventtypes.map((item) => {
                                return (<Dropdown.Item value={item.eventtype} key={item.eventtype} eventKey={item.eventtype} onClick={e => GetAlerts(item.eventtype)} onSelect={handleChangeEvent}  >
                                    <img src={`Images/${item.eventtype}_Blue.png`} className="icon_table" /> - {item.description}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td className="cell_alerts" style={{ textAlign: "center" }}>
                <Dropdown onSelect={eventKey => {
                    setToggleContents(icons[eventKey]);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={serviceDisabled} >
                        {!toggleContents ? <EnvelopeFill color="#0099CC" size={18} /> : toggleContents}
                    </Dropdown.Toggle>

                    <Dropdown.Menu value={service.idServiceType} >
                        {
                            servicestypes.map((item) => {
                                return (<Dropdown.Item value={item.idServiceType} key={item.idServiceType} eventKey={item.idServiceType} onClick={e => GetAlertsByChannel(item.idServiceType)} onSelect={handleChangeService} >
                                    {item.idServiceType === 1 ?
                                        <><EnvelopeFill color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                        : item.idServiceType === 3 ? <><Telephone color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                            : <><Phone color="#0099CC" size={18} /> - {item.codeServiceType}</>
                                    }
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td className="cell_alerts">
                <Dropdown onSelect={eventKey => {
                    setToggleAlerts(icons[eventKey]);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={alertDisabled} >
                        {!toggleAlerts ? <img src={`Images/${alertLevel[0]}-bullet.gif`} /> : toggleAlerts}
                    </Dropdown.Toggle>

                    <Dropdown.Menu value={service.alertLevel} >
                        {
                            alertLevel.map((item, index) => {
                                return (<Dropdown.Item id={item} value={item} key={index} eventKey={item} onSelect={handleChangeAlertLevel} >
                                    <img src={`Images/${item}-bullet.gif`} /> - {item}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td>
                <Dropdown onSelect={eventKey => {
                    setToggleRegions(<>
                        {regions.filter(item => item.idRegion === parseInt(eventKey)).map(types => (
                            <>
                                {types.regionName}
                            </>
                        ))}
                    </>);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" disabled={regionDisabled} variant="light">
                        {!toggleRegions ? regions.filter(item => item.idRegion === 1).map(reg => (
                            <>
                                {reg.regionName}
                            </>
                        )) : toggleRegions}
                    </Dropdown.Toggle>

                    <Dropdown.Menu >
                        {
                            regions.map((item) => {
                                return (<Dropdown.Item value={item.idRegion} key={item.idRegion} eventKey={item.idRegion} onSelect={handleChangeRegion} >
                                    {item.regionName}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td >
                <Dropdown onSelect={eventKey => {
                    setToggleLanguages(<>
                        {language.filter(item => item.key === eventKey).map(types => (
                            <>
                                {types.value}
                            </>
                        ))}
                    </>);
                }}>
                    <Dropdown.Toggle id="dropdown-custom-components" variant="light" disabled={languageDisabled}>
                        {!toggleLanguages ? language.filter(item => item.key === "en").map(types => (
                            <>
                                {types.value}
                            </>
                        )) : toggleLanguages}
                    </Dropdown.Toggle>
                    <Dropdown.Menu disabled={languageDisabled} value={service.language} >
                        {
                            language.map((item) => {
                                return (<Dropdown.Item value={item.key} key={item.key} eventKey={item.key} onSelect={handleChangeLanguage} >
                                    {item.value}
                                </Dropdown.Item>)
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </td>
            <td className="cell_alerts"><input className="input-checkbox" name="stopNight" type="checkbox" onChange={handleChangeCheckNight} /></td>
            <td className="cell_alerts"><input className="input-checkbox" name="enabled" type='checkbox' defaultChecked={service.enabled} onChange={handleChangeCheckEnabled} /></td>
            <td className="cell_alerts">
                <button type='button' className="btn btn_table btn-primary" style={{ backgroundColor: "red" }} onClick={() => props.onRequestSaveService(service)}><FaIcons.FaRegSave style={{ height: '20px' }} /></button> &nbsp;
                <button type='button' className="btn btn_table btn-primary" style={{ backgroundColor: "#ed7d31" }} onClick={() => props.onRequestCancelRow()}><FaIcons.FaArrowLeft style={{ height: '20px' }} /></button>
            </td>
        </tr>
    )

}

export { NewServiceRow };